/**
 * Cliente API para SmartPay (Microservicio de Pagos)
 *
 * Conecta a SmartPay (puerto 8040).
 * Usa el mismo token JWT de SmartHub para autenticacion.
 */

import axios from 'axios';
import { getSmartPayApiUrl } from '@/config/api';

const PAY_TIMEOUT = 10000; // 10 segundos

const buildUrl = (endpoint, pathParams = {}) => {
  const baseUrl = getSmartPayApiUrl();
  let url = `${baseUrl}${endpoint}`;

  Object.keys(pathParams).forEach(key => {
    url = url.replace(`:${key}`, encodeURIComponent(pathParams[key]));
  });

  return url;
};

const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const payApiClient = {
  get: async (endpoint, pathParams = {}, queryParams = {}) => {
    const url = buildUrl(endpoint, pathParams);
    const response = await axios.get(url, {
      headers: getAuthHeaders(),
      params: queryParams,
      timeout: PAY_TIMEOUT,
    });
    return response.data;
  },

  post: async (endpoint, pathParams = {}, data = {}) => {
    const url = buildUrl(endpoint, pathParams);
    const response = await axios.post(url, data, {
      headers: getAuthHeaders(),
      timeout: PAY_TIMEOUT,
    });
    return response.data;
  },

  put: async (endpoint, pathParams = {}, data = {}) => {
    const url = buildUrl(endpoint, pathParams);
    const response = await axios.put(url, data, {
      headers: getAuthHeaders(),
      timeout: PAY_TIMEOUT,
    });
    return response.data;
  },

  delete: async (endpoint, pathParams = {}) => {
    const url = buildUrl(endpoint, pathParams);
    const response = await axios.delete(url, {
      headers: getAuthHeaders(),
      timeout: PAY_TIMEOUT,
    });
    return response.data;
  },
};

export default payApiClient;
